import React from 'react';
import PropTypes from 'prop-types';
import SiteNavLinksList from '../SiteNavLinksList';
import './DesktopExpandedNav.scss';

const DesktopExpandedNav = props => {
  if (!props.showSubMenu) {
    return null;
  }

  return (
    <div className="DesktopExpandedNav">
      <div className="DesktopExpandedNav__links-container"
        style={{
          // NB: For the next iteration of the nav,
          // the spacing between columns will be programmatically
          // determined. But for now, we only have 2 columns which
          // means that when they share the space of the container
          // 50/50, there's lots of white space around the columns.
          // I have been asked to minimise that.
          gridTemplateColumns: `repeat(${props.numOfColumns}, 16rem)`
        }}>
        {props.navLinksLists?.map((list) => (
          <SiteNavLinksList
            {...list}
            parentItemLabel={props.parentItemLabel}
            key={list.columnKey}
          />
        ))}
      </div>
    </div>
  );
};

DesktopExpandedNav.propTypes = {
  navLinksLists: PropTypes.array,
  numOfColumns: PropTypes.number,
  showSubMenu: PropTypes.bool,
  parentItemLabel: PropTypes.string,
};

export default DesktopExpandedNav;
